import type {
  AccountSelectionState,
  SetAvailableAccountsPayload,
  SetSelectedAccountPayload,
  UpdateAccountSelectionPayload,
} from './types'
import { AccountSelectionActionTypes } from './actionTypes'

const initialState: AccountSelectionState = {
  selectedAccountIds: {},
  availableAccounts: [],
  isLoading: false,
  error: null,
  tenantPartnerId: '',
}

export const reducer = (
  state: AccountSelectionState = initialState,
  action: { type: string; payload?: any }
): AccountSelectionState => {
  switch (action.type) {
    case AccountSelectionActionTypes.SET_SELECTED_ACCOUNT: {
      const { accountId, product, cloud } =
        action.payload as SetSelectedAccountPayload

      return {
        ...state,
        selectedAccountIds: {
          ...state.selectedAccountIds,
          [product.toUpperCase()]: { [cloud]: accountId },
        },
        error: null,
      }
    }

    case AccountSelectionActionTypes.SET_AVAILABLE_ACCOUNTS: {
      const { accounts } = action.payload as SetAvailableAccountsPayload

      return {
        ...state,
        availableAccounts: Array.isArray(accounts) ? accounts : [],
        isLoading: false,
        error: null,
      }
    }

    case AccountSelectionActionTypes.UPDATE_ACCOUNT_SELECTION: {
      const payload = action.payload as UpdateAccountSelectionPayload

      return {
        ...state,
        selectedAccountIds:
          payload.selectedAccountIds !== undefined
            ? { ...state.selectedAccountIds, ...payload.selectedAccountIds }
            : state.selectedAccountIds,
        availableAccounts:
          payload.availableAccounts !== undefined
            ? Array.isArray(payload.availableAccounts)
              ? payload.availableAccounts
              : []
            : Array.isArray(state.availableAccounts)
              ? state.availableAccounts
              : [],
        error: null,
      }
    }

    case AccountSelectionActionTypes.CLEAR_ACCOUNT_SELECTION: {
      return {
        ...initialState,
      }
    }

    case AccountSelectionActionTypes.ACCOUNT_SELECTION_LOADING: {
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    }

    case AccountSelectionActionTypes.ACCOUNT_SELECTION_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    }

    case AccountSelectionActionTypes.ACCOUNT_SELECTION_CLEANUP: {
      return {
        ...state,
        isLoading: false,
        error: null,
      }
    }
    case AccountSelectionActionTypes.CREATE_ACCOUNT_LOADING: {
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    }

    case AccountSelectionActionTypes.CREATE_ACCOUNT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
      }
    }

    case AccountSelectionActionTypes.CREATE_ACCOUNT_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    }

    case AccountSelectionActionTypes.GET_ACCOUNT_LOADING: {
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    }

    case AccountSelectionActionTypes.GET_ACCOUNT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        tenantPartnerId: action.payload.partnerId,
      }
    }

    case AccountSelectionActionTypes.GET_ACCOUNT_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    }

    case AccountSelectionActionTypes.UPDATE_ACCOUNT_LOADING: {
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    }

    case AccountSelectionActionTypes.UPDATE_ACCOUNT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
      }
    }

    case AccountSelectionActionTypes.UPDATE_ACCOUNT_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    }

    case AccountSelectionActionTypes.DELETE_ACCOUNT_LOADING: {
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    }

    case AccountSelectionActionTypes.DELETE_ACCOUNT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        // Remove the deleted account from available accounts
        availableAccounts: (Array.isArray(state.availableAccounts)
          ? state.availableAccounts
          : []
        ).filter(account => account.id !== action.payload),
      }
    }

    case AccountSelectionActionTypes.DELETE_ACCOUNT_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    }

    default:
      return state
  }
}
